import React, { useContext, useEffect } from 'react';
import { Outlet, Route } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { Navigate } from 'react-router-dom/dist';
import { useSelector } from 'react-redux';


const PrivateRoute = ({ children }) => {

    // const { user } = useContext(UserContext)
    const user = useSelector(state => state.user)
    // console.log('user from useSelector at PrivateROute: ', user);

    return user && user.isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default PrivateRoute;

export const EmployeeRoute = ({ children }) => {
    const user = useSelector(state => state.user);
    const groupName = user?.account?.groupWithRoles?.name
        || user?.userData?.groupWithRoles?.name
        || user?.userData?.userData?.Group?.name
        || '';
    const userCode = user?.userData?.userCode || user?.userData?.userData?.userCode || '';
    const isEmployee = ['Employee', 'Admin', 'NhanVien'].includes(groupName)
        || userCode.toUpperCase().startsWith('NV');

    if (!user?.isAuthenticated) return <Navigate to="/login" replace />;
    return isEmployee ? children : <Navigate to="/" replace />;
};

export const ClientRoute = ({ children }) => {
    const user = useSelector(state => state.user);
    const groupName = user?.account?.groupWithRoles?.name
        || user?.userData?.groupWithRoles?.name
        || user?.userData?.userData?.Group?.name
        || '';
    const userCode = user?.userData?.userCode || user?.userData?.userData?.userCode || '';
    const isEmployee = ['Employee', 'Admin', 'NhanVien'].includes(groupName)
        || userCode.toUpperCase().startsWith('NV');

    if (!user?.isAuthenticated) return <Navigate to="/login" replace />;
    return isEmployee ? <Navigate to="/employee/parking-lots" replace /> : children;
};
